import React from 'react'
import { createContext, useContext, useMemo} from "react";
import { useAuth } from './Auth';

const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const auth = useAuth();

  const value = useMemo(
    () => ({
      auth,
      get: async(path, refresh)=>{ return auth.userData&&auth.userData.id_token? await Api.get('api/'+path, refresh, auth.userData.id_token):null},
      put: async(path, value)=>{ return auth.userData&&auth.userData.id_token? await Api.put('api/'+path, value, auth.userData.id_token):null},
      post: async(path, value)=>{ return auth.userData&&auth.userData.id_token? await Api.post('api/'+path, value, auth.userData.id_token):null},
      delete: async(path, value)=>{ return auth.userData&&auth.userData.id_token? await Api.delete('api/'+path, value, auth.userData.id_token):null},
    }),
    [auth]
  );

  return (
    <ApiContext.Provider value={value}>
        {children}
    </ApiContext.Provider>
  )
};

export const useApi = () => {
  return useContext(ApiContext);
};


const Api = {
    get: async(path, refresh, token)=>{
      const param = {
        headers:{'Authorization':'Bearer ' + token}
      }
      if(refresh){
        param.cache = "reload";
      }
      var response = await fetch(path, param);
      if(!response.ok) throw new Error(`Get Response ${response.status}: ${path}`);
      var ret = await response.json()
      return ret;
    },
    put: async(path, value, token)=>{
      const param = {
        method: 'PUT',    
        headers: { 'Content-Type': 'application/json' ,'Authorization':'Bearer ' + token},
        body: JSON.stringify(value)
      }
      var response = await fetch(path, param);
      if(!response.ok) throw new Error(`Put Response ${response.status}: ${path}`);
      var ret = await response.json();
      return ret;
    },
    post: async(path, value, token)=>{
      const param = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization':'Bearer ' + token},
        body: JSON.stringify(value)
      }
      var response = await fetch(path, param); 
      if(!response.ok) throw new Error(`Post Response ${response.status}: ${path}`);  
      var ret = await response.json();
      return ret;
    },
    delete: async(path, value, token)=>{
      const param = {
        method: 'DELETE',
        headers:{'Content-Type': 'application/json', 'Authorization':'Bearer ' + token},
        body: JSON.stringify(value)
      }
      var response = await fetch(path, param);
      if(!response.ok) throw new Error(`Delete Response ${response.status}: ${path}`);
      var ret = await response.json();
      return ret;
    }
  };

 // export default Api